import { render, staticRenderFns } from "./Serials.vue?vue&type=template&id=29ffe3fc&"
import script from "./Serials.vue?vue&type=script&lang=js&"
export * from "./Serials.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports